import React from 'react'
import Typography from "@material-ui/core/Typography";

export function getPriceContainer(price, active = true, mdUp) {
    return <>
        {
            (price).toString().includes('.')
                ? <Typography style={{display: 'flex'}} color={active ? "textPrimary" : "textSecondary"} component={"div"}>
                    <span style={{display: 'flex', fontSize: mdUp ? 14 : 12}}>{price.toString().split('.')[0]}
                    <span style={{fontSize: 11, marginBottom: 'auto', display: 'block', fontWeight: 700,}}>
                        {(price).toString().split('.')[1]}
                    </span>
                    </span>
                    <span>&#8372;</span>
                </Typography>
                : <Typography style={{display: 'flex'}} color={active ? "textPrimary" : "textSecondary"} component={"div"}>
                    <span style={{display: 'flex', fontSize: mdUp ? 14 : 12}}>{price}
                        <span style={{fontSize: 11, marginBottom: 'auto', display: 'block', fontWeight: 700,}}>00</span>
                    </span>
                    <span>&#8372;</span>
                </Typography>
        }
    </>;
}